import { countryName } from '../../lib/countries.ts';
import { PageHeader } from '../../components/ui/PageHeader.tsx';
import { PageActions } from '../../components/ui/PageActions.tsx';
import { Link } from 'react-router';
import { useMe } from '../../lib/auth.tsx';
import { useGridQuery, useGridState } from '../../lib/grid.ts';
import { OUTS_STATUS, d10, type OutsourcingRow } from '../../lib/vendors.ts';
import { DataTable, type Column } from '../../components/DataTable.tsx';
import { Badge, LinkButton } from '../../components/ui/Button.tsx';
import { can } from '../../lib/perm.ts';

const columns: Column<OutsourcingRow>[] = [
  { key: 'title', label: '위탁 업무', filter: 'text', render: (o) => <><Link className="text-accent-strong hover:underline" to={`/vendors/outsourcings/${o.id}`}>{o.title}</Link>{o.hasSensitivePii && <span className="ml-1"><Badge tone="danger">민감</Badge></span>}</> },
  { key: 'vendorId', label: '수탁사', width: '10rem', filter: 'select', sortable: false, render: (o) => o.vendorId ? <><Link className="hover:underline" to={`/vendors/${o.vendorId}`}>{o.vendorName}</Link>{o.vendorForeign && <span className="ml-1" title={countryName(o.vendorCountry)}><Badge tone="warning">국외</Badge></span>}</> : <Badge tone="warning">미지정</Badge> },
  { key: 'deptId', label: '부서', width: '7rem', filter: 'select', sortable: false, render: (o) => o.deptId ? o.deptName : <Badge tone="warning">미배정</Badge> },
  { key: 'ownerUserId', label: '담당자', width: '7rem', filter: 'select', sortable: false, render: (o) => o.ownerName || '—' },
  { key: 'status', label: '상태', width: '7rem', filter: 'select', render: (o) => <Badge tone={OUTS_STATUS[o.status]?.tone ?? 'neutral'}>{OUTS_STATUS[o.status]?.label ?? o.status}</Badge> },
  { key: 'contractCount', label: '계약', width: '3.5rem', align: 'right', sortable: false },
  { key: 'publishedInPrivacyPolicy', label: '처리방침', row: 2, span: 1, filter: 'bool', align: 'center', render: (o) => o.publishedInPrivacyPolicy ? '반영' : <span className="text-red-700">미반영</span> },
  { key: 'endDate', label: '계약 종료', row: 2, span: 1, filter: 'date', render: (o) => d10(o.endDate) },
  { key: 'lastAuditAt', label: '최근 점검', row: 2, span: 1, filter: 'date', render: (o) => d10(o.lastAuditAt) },
  { key: 'actions', label: '작업', row: 2, span: 1, sortable: false, render: (o) => <LinkButton variant="ghost" to={`/vendors/outsourcings/new?from=${o.id}`}>복제</LinkButton> },
  { key: 'lastTrainingAt', label: '최근 교육', row: 2, span: 1, filter: 'date', render: (o) => d10(o.lastTrainingAt) },
];

/** 위탁 업무 목록 + 등록 */
export function OutsourcingsPage() {
  const me = useMe();
  const { state, set } = useGridState('o', { sort: { col: 'title', dir: 'asc' } });
  const data = useGridQuery<OutsourcingRow>('outsourcings-grid', '/vendors/outsourcings/grid', state);
  const canWrite = can(me.data, 'vendor.manage');
  return (
    <div>
      <PageHeader title="위탁 업무" />
      {data.isError && <div className="text-red-600 text-sm mb-2">{(data.error as Error).message}</div>}
      <DataTable id="outsourcings" columns={columns} data={data.data} state={state} onChange={set} isFetching={data.isFetching} />
      <PageActions>{canWrite && <LinkButton to="/vendors/outsourcings/new">위탁 업무 등록</LinkButton>}</PageActions>
    </div>
  );
}
